module.exports = __webpack_public_path__ + "fonts/LiberationSans.4ce6215c.ttf";